export const PermissionMixin = {
    data() {
        return {
            loggedInUser: {}
        }
    },
    methods: {
        can(action = '', jobDetails = {}) {
            const allowedActions = Array.isArray(jobDetails)
                  ? jobDetails
                  : jobDetails?.permissions || [];

            const loggedInUser = this.$localEncrypt.getLoggedInUser() || JSON.parse(localStorage.getItem('loggedInUser'));
            const permissions = window._9abc1234_1697898000000 ?? JSON.parse(localStorage.getItem('permissions'));

            let permissionsArray = allowedActions.length ? allowedActions : permissions;
            
            if ( !permissionsArray ) {
                permissionsArray = this.extractPermissions(loggedInUser, true);
            }
            
            return permissionsArray?.includes(action) || loggedInUser.is_system_admin;
        },

        extractPermissions(data, returnArray = false) {
            let permissions = [];
            
            const adminRoles = data?.roles?.filter(role => !!role.is_admin_role);
            adminRoles?.forEach(role => {
                permissions = [...permissions, ...role?.permissions?.map(permission => permission.name)];
            });
            
            localStorage.setItem('permissions', JSON.stringify(permissions));
            
            if ( returnArray ) return permissions;
        },

        logUserIn(responseData, intendedUrl) {
            const url = document.URL;
            this.extractPermissions(responseData);
            this.$store.commit('SET_LOGGED_IN_USER', responseData)
            const first_name = responseData?.name?.split(' ')[0] ?? '';
            const last_name = responseData?.name?.split(' ')[1] ?? '';
            this.$localEncrypt.saveData('appUserDetails', { ...responseData, company: sessionStorage.getItem('company'), first_name, last_name })
            location.href = url.redirect ? url.redirect : intendedUrl;
        },

        formatTimezone(value) {
            const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            return this.$momentTimezone(value).tz(tz).fromNow();
        },

        actualTimeFormat(value, valueFormat) {
            const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            return this.$momentTimezone(value).tz(tz).format(valueFormat);
        }
    },
    beforeMount() {
        const adminMountElement = document.getElementById('adminMount')
        
        if(!JSON.parse(localStorage.getItem('loggedInUser')) && adminMountElement) {
            this.$http.get('v2/admin/user/session')
		    .then(res => {
                this.loggedInUser = res?.data?.data;
                // sessionStorage.setItem('loggedInUser', JSON.stringify(res?.data?.data));
		    })
        }
    }
}
